// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ErrorComponent = require("../../reason/common/Error/ErrorComponent.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let ProfilePageSocialMediaForm = require("./ProfilePageSocialMediaForm.bs.js");
let ProfilePageProfilePhotoForm = require("./ProfilePageProfilePhotoForm.bs.js");
let ProfilePageRelayQuery_graphql = require("../../__generated__/ProfilePageRelayQuery_graphql.bs.js");
let ProfilePageAddressInformationForm = require("./ProfilePageAddressInformationForm.bs.js");
let ProfilePagePersonalInformationForm = require("./ProfilePagePersonalInformationForm.bs.js");
let ProfilePageBiographyInformationForm = require("./ProfilePageBiographyInformationForm.bs.js");

let convertVariables = ProfilePageRelayQuery_graphql.Internal.convertVariables;

let convertResponse = ProfilePageRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = ProfilePageRelayQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, ProfilePageRelayQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, ProfilePageRelayQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(ProfilePageRelayQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(ProfilePageRelayQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(ProfilePageRelayQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(ProfilePageRelayQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function ProfilePageRelay(props) {
  let data = use(undefined, undefined, undefined, undefined);
  let agent = data.currentlyLoggedInAgent;
  if (agent !== undefined) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ProfilePagePersonalInformationForm.make, {
            agent: agent.fragmentRefs
          })
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ProfilePageProfilePhotoForm.make, {
            agent: agent.fragmentRefs
          })
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ProfilePageAddressInformationForm.make, {
            agent: agent.fragmentRefs
          })
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ProfilePageBiographyInformationForm.make, {
            agent: agent.fragmentRefs
          })
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ProfilePageSocialMediaForm.make, {
            agent: agent.fragmentRefs
          })
        })
      ]
    });
  } else {
    return JsxRuntime.jsx(ErrorComponent.make, {
      message: "No data. Please refresh or try again later..."
    });
  }
}

let make = ProfilePageRelay;

exports.Query = Query;
exports.make = make;
/* use Not a pure module */
